import { environment } from "../config/environment";
import { customFetch } from "./Auth"

export const getModelEvalStats = async (startDate = "", endDate = "", sample) => {
  try {
    // Build query string based on provided dates
    let queryString = '';
    
    if (startDate && endDate) {
      queryString = `?startDate=${startDate}&endDate=${endDate}&sample=${sample}`;
    } else if (startDate) {
      queryString = `?startDate=${startDate}&sample=${sample}`;
    } else {
      queryString = `?sample=${sample}`;
    }
    
    const res = await customFetch(
      `${environment.apiUrl}/eval/${queryString}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        },
      }
    );

    if (res.ok) {
      const data = await res.json();
      
      return data;
    } else {
      console.error("Error fetching model evaluation stats:", res.statusText);
      throw new Error("Error fetching model evaluation stats");
    }
  } catch (error) {
    console.error("Error fetching model evaluation stats:", error);
    throw error;
  }
}